import {createCommand, LexicalCommand} from 'lexical';

export const HANDLE_AI_TEXT_SUGGESTION: LexicalCommand<{
    enhancementType: string;
    enhancementOption: string;
    selectionMode?: boolean;
}> = createCommand();

export const INSERT_STRING_HTML: LexicalCommand<{
    html: string;
}> = createCommand();

export const REPLACE_SELECTION_HTML: LexicalCommand<{
    html: string;
}> = createCommand();
